<template>
    <div class="stream-item-base">
        <div 
            class="stream-item-line" 
            :style="lineStyles"
        ></div>
        <slot />
    </div>
</template>

<style lang="scss">
    .stream-item-base {
        position: relative;
        margin-left: 4rem;

        .stream-item-line {
            content: " ";
            position: absolute;
            top: 0; left: -2.8rem;
            bottom: -1.1rem;
            width: 1px;
            border-right-width: 2px;
        }

        &:last-of-type {
            .stream-item-line {
                bottom: 0;
            }
        }
    }
</style>

<script>
    import StreamItemSupport from './StreamItemSupport'

    export default {
        mixins: [StreamItemSupport],
        computed: {
            lineStyles() {
               let styles = 'border-right-color: ' + this.lineColour + ';'
               styles += 'border-right-style: ' + this.lineType + ';'
               return styles
            }
        }
    }
</script>